'use client';

import React from 'react';

export const LoadingModal = ({ isSubmitting }) => {
  if (!isSubmitting) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">
        <div className="flex flex-col items-center space-y-4">
          <img
            src="/img/icons/refresh-cw-05.svg"
            alt="Processing"
            className="w-10 h-10 animate-spin"
          />
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Registration in progress</h3>
            <p className="text-sm text-gray-600">
              We&#39;re processing your registration. This may take a few moments.
              Please don&#39;t close this window.
            </p>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
            <div className="bg-blue-600 h-2.5 rounded-full animate-pulse" style={{ width: '100%' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};
